
import axios from "axios";


export const getVideoDetails = async (videoId) => {
    const  response = await axios.get('https://d2t4p66pm5.execute-api.eu-west-1.amazonaws.com/dev/' + videoId)
    return response.data
}


export const getVideoDetails_ = async (videoId) => {
    const  response = await axios.get('/test/video1.json')
    return response.data
}



